import { Fragment, useEffect, useState } from "react";
import Spinner from "../../spinner/Spinner";
import "./ReportUserRequest.css";
import { GetCampaign, GetCampaignProcessDetails, UpdateCampaignProcess } from "../../../Services";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment-timezone";

const ReportUserRequest = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [pageError, setPageError] = useState(false);
    const { processId } = useParams();
    const [process, setProcess] = useState();
    const [campaign, setCampaign] = useState();

    useEffect(() => {
        getCampaignProcessDetails();
    }, []);

    useEffect(() => {
        if (process && campaign) {
            setIsLoading(false);
        }
    }, [process, campaign]);

    const getCampaignProcessDetails = async () => {
        if (processId) {
            const response = await GetCampaignProcessDetails(processId);

            if (response && response.id) {
                setProcess(response);

                if (response.status === "RequestSentToUser" || response.status === "Pending") {
                    await getCampaign(response.campaignId);
                } else {
                    setIsLoading(false);
                    setPageError(true);
                }
            } else {
                setIsLoading(false);
                setPageError(true);
            }
        }
    };

    const getCampaign = async (campaignId) => {
        const response = await GetCampaign(campaignId);

        if (response) {
            setCampaign(response);
        }
    };

    const addReportToQueue = async () => {
        setIsSubmitting(true);

        let data = {
            campaignId: campaign.id,
            type: "Report",
            status: "Pending",
            startDate: moment(),
        };

        const response = await UpdateCampaignProcess(processId, data);

        if (!response.success) {
            console.error(response);
            setIsSubmitting(false);
        } else {
            toast.success("Report added to queue.");

            setTimeout(function () {
                getCampaignProcessDetails();
                setIsSubmitting(false);
            }, 1000);
        }
    };

    return (
        <div className="report-user-request-container">
            {isLoading && <Spinner />}

            {!isLoading && (
                <div className="notice-wrapper">
                    {pageError ? (
                        <div className="page-error">
                            <h4>Something went wrong. Please, contact our support.</h4>
                        </div>
                    ) : (
                        <div>
                            {process.status === "Pending" ? (
                                <Fragment>
                                    <h4 className="mb-2">The report is in the queue, waiting for processing.</h4>
                                    <h4 className="mb-2">When the report is completed and reviewed, we'll send you a notification.</h4>
                                </Fragment>
                            ) : (
                                <Fragment>
                                    <h4 className="mb-2">After you add report to the queue, we'll run the building report process.</h4>
                                    <h4 className="mb-2">When the report is completed and reviewed, we'll send you a notification.</h4>
                                    <button className="btn btn-primary mt-3" onClick={addReportToQueue}>
                                        {isSubmitting ? (
                                            <Fragment>
                                                <span className="spinner-border m-0 me-2" />
                                                <span>Adding To Queue</span>
                                            </Fragment>
                                        ) : (
                                            <span>Add To Queue</span>
                                        )}
                                    </button>
                                </Fragment>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default ReportUserRequest;
